import React, { useState } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../../layouts/PageLayout";
import { PageHeader } from "../../../components/v3";
import { AddEditStage, StageList } from "../../../components/library";
import { useHasPermission } from "../../../utils";
import { CREATE_STAGE } from "../../../constants";

export const Stages = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const hasCreateStage = useHasPermission(CREATE_STAGE);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasCreateStage && {
      buttonText: "Add Stage",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];
  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader title="Stages" subtitle={`${totalCount} Stages`} buttons={buttons} />
        </Box>

        {/* table section */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <StageList totalCount={totalCount} setTotalCount={setTotalCount} onSuccess={handleReload} reloadData={reload} />
        </Box>
      </PageLayout>

      {/* add stage modal */}
      <AddEditStage open={openModal} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
